import { useContext, useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { login } from '../service/fhirAPI';
import { ShowContext} from '../../context/Context';
import { useNavigate } from 'react-router';
import './usercam.css'

const Usercam = () => {
    const webcamRef = useRef(null);
    const [flag, setFlag] = useState(0);
    const {giveWholeData,givePatientData} = useContext(ShowContext)
    const navigate =useNavigate()
const ctx = useContext(ShowContext)
    useEffect(() => {
        let intervalId;

        const captureImage = async() => {
            const imageSrc = webcamRef?.current?.getScreenshot();
            const base = imageSrc?.replace(/^data:.+;base64,/, '');
            const data = await login(base);
            if(data?.flag === 1 && data.userId==="6ee74236c34454d8b6cdb3039e0db86f") { 
                setFlag(true);
                // const person = await givePersonDataById(data?.userId)
                // console.log(person)
                givePatientData("mike")
                giveWholeData("50732")

                // givePatientData(person?.firstname)
                // giveWholeData(person?.fhir)
                navigate('/patientViewer')
            }
            if(data?.flag === 1 && data.userId==="5dd25f14a04c550f8e6d5e73fa29bc83") { 
                setFlag(true);
                // const person = await givePersonDataById(data?.userId)
                // console.log(person)
                givePatientData("josh")
                giveWholeData("16524")

                // givePatientData(person?.firstname)
                // giveWholeData(person?.fhir)
                navigate('/patientViewer')
            }
        };

        if (flag===0 && ctx.isModalOpen) {
            intervalId = setInterval(captureImage, 300); // Capture image every second
        }

        return () => {
            clearInterval(intervalId); // Clean up interval on component unmount
        };
    }, [flag,givePatientData,giveWholeData,navigate,ctx.isModalOpen]);

    return (
        <div className='authCam'>
            
         <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" className='authCam__user'/>
        </div>
    );
};

export default Usercam;

